import clsx from "clsx"
import { FC, useMemo } from "react"
import { useTranslation } from "react-i18next"
import { IUpgradeBuilding } from "store/apis/clanAltarAPI/types"
import { useUserClan } from "hooks/useUserClan"
import spaceNumber from "utils/spaceNumber"
import { Button, IButton } from "ui/@button"
import { bonesIcon, goldIcon } from "assets/icons"
import styles from "./index.module.scss"

const currencyIcon: any = {
  bones: bonesIcon,
  gold: goldIcon
}

interface IButtonUpgradeClanBuild extends IButton {
  updatePrice: IUpgradeBuilding[]
  upgradeAvailable?: boolean
  titleKey?: string
}

export const ButtonUpgradeClanBuild: FC<IButtonUpgradeClanBuild> = ({
  updatePrice,
  upgradeAvailable,
  titleKey,

  className,
  disabled,
  ...props
}) => {
  const { t } = useTranslation()
  const { isModeratorPermissions: isOwnerOrAdviser } = useUserClan()

  const titleTextKey = useMemo(() => {
    if (titleKey) return titleKey

    if (upgradeAvailable) return "upgrade"

    return "maxLevel"
  }, [upgradeAvailable, titleKey])

  if (!isOwnerOrAdviser) return null

  return (
    <Button
      className={clsx(styles.ButtonUpgradeClanBuild, className)}
      triangleTopPosLeft="none"
      triangleBottomPosLeft="150px"
      disabled={!upgradeAvailable || disabled}
      {...props}
    >
      <p>{t(titleTextKey)}</p>
      {updatePrice.map((e) => (
        <div
          className={clsx(styles.ButtonUpgradeClanBuild_currency)}
          key={e.currency}
        >
          <img className="icon" src={currencyIcon[e.currency]} alt="gold" />
          <p>{spaceNumber(e.value)}</p>
        </div>
      ))}
    </Button>
  )
}
